// @import dependencies
import React, { CSSProperties, useEffect, useState } from 'react'
import shortId from 'shortid';
// @end dependencies

// @import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { Link } from 'react-router-dom';
import ForumCard from 'app_components/commons/ForumCard/ForumCard';
import IconComponent from 'app_components/commons/icons';
import Slider from 'react-slick';
// @end components

// @import types
// @end types

// @import services
import { routingService } from 'app_services/routingService';
// @end services

// @import hooks
import { useColors } from 'app_hooks/useColors';
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ForumSliderModule.scss'
import ForumService from 'app_services/admin/forum/forumService';
import { IForumListItem } from 'app_types/admin/forum/forumTypes';
// @end styles

interface IForumSliderModuleProps {
  className?: string
  style?: CSSProperties
  id?: string
  title?: string
  description?: string
  hideMoreInformation?: boolean
}

const ForumSliderModule: React.FC<IForumSliderModuleProps> = (props) => {

  const [colors] = useColors()
  const { windowWidth } = useWindowWidth()
  const [forums, updateForums] = useState<IForumListItem[]>([]);

  const forumService = new ForumService()

  useEffect(() => {
    getForums()
  },[])

  const getForums = async () => {
    const response: any = await forumService.getFeaturedForums()
    if (response?.code === 200 && response.forums?.length) {
      updateForums(response.forums)
    }
  }

  const getNumberItems = () => {
    if(windowWidth < 576){
      return 1
    }
    if(windowWidth < 991){
      return 2
    }
    return 4
  }

  return(
    forums?.length ?
    <div
      className={`forum_slider_module-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      {props.title ?
        <TextComponent
          type='title'
          className='title-page-teachers'
        >
          {props.title}
        </TextComponent>
      :null}
      {props.description ?
        <TextComponent
          type='text'
          style={{ textAlign: 'center' }}
        >
          {props.description}
        </TextComponent>
      :null}
      {forums.length ?
        <Slider
          arrows={true}
          infinite={(forums.length >= getNumberItems()) ? true : false}
          slidesToShow={getNumberItems()}
          nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
          prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
        >
          {forums.map((_item) => (
            <div
              key={shortId.generate()}
              className='container-forum-card-slider'
            >
              <ForumCard
                forumId={_item._id}
                title={_item.title}
                description={_item.description}
                date={_item.postDate}
              />
            </div>
          ))}
        </Slider>
      :null}
      {!props.hideMoreInformation ?
        <Link
          to={routingService.getPublicPath('/forums')}
          style={{textDecoration: 'none'}}
        >
          <TextComponent
            type='text'
            style={{color: 'var(--secondary)', textAlign: 'center'}}
          >
            Mas información
          </TextComponent>
        </Link>
      :null}
    </div>
  :null
  );
}

// ======================================
// Flecha
// ======================================
const CustomArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      {props.icon}
    </div>
  );
}


export default ForumSliderModule;
